/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { ScenarioButton } from './scenarioButton'
import type { ScenarioHotspot } from './scenarioHotspot'
import type { ScenarioNodeWithDetailsAllOfVideo } from './scenarioNodeWithDetailsAllOfVideo'
import type { ScenarioTelop } from './scenarioTelop'
import type { SurveyQuestionWithOptions } from './surveyQuestionWithOptions'

export type ScenarioNodeWithDetailsAllOf = {
  /** @nullable */
  video: ScenarioNodeWithDetailsAllOfVideo
  surveyQuestions: SurveyQuestionWithOptions[]
  /** 動画内のクリック領域（ワイド型の動画ノードのみ・ADR-0022）。order 昇順 */
  hotspots: ScenarioHotspot[]
  telops: ScenarioTelop[]
  buttons: ScenarioButton[]
}
